import React, { useMemo } from 'react';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import fiverrLearnCoursesList from '@fiverr-private/fiverr_learn/src/components/CourseList/coursesList.json';
import { Header, Content, ContentsWrapper } from '../../../common/ModalBlocks';
import { useLocalizationContext, DATETIME_ELEMENT_STYLES } from '../../../../contexts/LocalizationContext';
import FiverrLearnLogo from './FiverrLearn.svg';

import classes from './index.module.scss';

const T_KEY = 'freelancer_page.modal.fiverr_learn';

/** @type {import('./index').FiverrLearn} */
export const FiverrLearn = ({ courses = [] }) => {
    const { dateTimeFormat } = useLocalizationContext();

    const transformDate = (seconds) =>
        dateTimeFormat(new Date(seconds * 1000), {
            year: DATETIME_ELEMENT_STYLES.NUMERIC,
            month: DATETIME_ELEMENT_STYLES.SHORT,
        });

    const transformedCoursesList = useMemo(
        () =>
            fiverrLearnCoursesList.coursesList.reduce(
                (acc, course) => ({
                    ...acc,
                    [course.id]: { name: course.name, img: course.img },
                }),
                {}
            ),
        []
    );

    return (
        <div className={classes.wrapper}>
            <Header
                title={
                    <div className={classes.title}>
                        <I18n k={`${T_KEY}.title`} />
                        <div>
                            <img src={FiverrLearnLogo} className={classnames(classes.fiverrLearnLogo, 'm-l-16')} />
                        </div>
                    </div>
                }
            />
            <ContentsWrapper>
                {courses.map((course) => (
                    <Content
                        subtitleClassName={classes.subtitle}
                        icon={<img src={transformedCoursesList[course.id].img} className={classes.icon} />}
                        key={course.id}
                        title={transformedCoursesList[course.id].name}
                        description={transformDate(course.updatedAt)}
                    />
                ))}
            </ContentsWrapper>
        </div>
    );
};
